import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useSelector } from 'react-redux';
import { computeCartFees, feeConfigFromCountryRow } from '../../utils/fees';

export default function BookTicketList(){
    const selectedEvent=useSelector(state=>state.event.selectTickets);
    const country = useSelector(state => state.event.country);
    const feeRow = useSelector(state => (state.event.getCountryFeeListDetails || []).find(detail => detail.country === country));
    const currency = feeRow?.currency;

    const feeConfig = feeConfigFromCountryRow(feeRow);
    // Per-config buyer breakdown (subtotal / serviceFee / paymentFee / total),
    // matching Payment.jsx and the backend. Fees are ORDER-level here — the
    // payment fee is charged ONCE for the whole order, not per ticket — so they
    // are shown as single summary lines below the ticket rows rather than
    // replicated onto each row (which multiplied the flat fee by the quantity).
    const { subtotal, serviceFee, paymentFee, total } =
        computeCartFees(selectedEvent?.selectedTicket, feeConfig);

    const amountFormatter = (amount) => {
      const formatted = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
      }).format(amount);

      return formatted;
  };
    return (
        <>
    <Accordion>
        <AccordionSummary
          expandIcon={<ArrowDropDownIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography sx={{fontWeight:600}}>
            <img src='/assets/images/hand_card.png' style={{marginRight:'15px'}}/>
            Total:${amountFormatter(total)} {currency} - {selectedEvent?.selectedTicket?.length} Tickets
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <table className='table'>
            <thead>
            <tr>
                <th>Ticket</th>
                <th>Price</th>
                <th>Qty</th>
            <th>SubTotal</th>
            </tr>
            </thead>
            <tbody>
                {selectedEvent?.selectedTicket?.map((item,index)=>(
 <tr key={index}>
 <td>{item.name}</td>
 <td><p  className='p-0 m-0'>{currency}</p>
 <p>${parseFloat(item.fee).toFixed(2)}</p></td>
 <td>1</td>
 <td><p className='p-0 m-0'>{currency}</p>
 <span>${parseFloat(item.fee).toFixed(2)}</span></td>
</tr>
                ))}

            </tbody>
            <tfoot>
            {/* Order-level fees, shown ONCE for the whole order (matches
                Payment.jsx and the backend) — never per ticket. */}
            <tr>
                <td colSpan={3}>Subtotal</td>
                <td>{currency} ${amountFormatter(subtotal)}</td>
            </tr>
            {serviceFee > 0 && (
            <tr>
                <td colSpan={3}>Service Fee</td>
                <td>{currency} ${amountFormatter(serviceFee)}</td>
            </tr>
            )}
            {paymentFee > 0 && (
            <tr>
                <td colSpan={3}>Processing Fee</td>
                <td>{currency} ${amountFormatter(paymentFee)}</td>
            </tr>
            )}
            <tr>
                <td colSpan={3}><strong>Total</strong></td>
                <td><strong>{currency} ${amountFormatter(total)}</strong></td>
            </tr>
            </tfoot>
          </table>
        </AccordionDetails>
      </Accordion>
        </>
    );
}
